import { render, staticRenderFns } from "./ModalCompraSuspensa.vue?vue&type=template&id=ddf85f58&scoped=true"
import script from "./ModalCompraSuspensa.vue?vue&type=script&lang=js"
export * from "./ModalCompraSuspensa.vue?vue&type=script&lang=js"
import style0 from "./ModalCompraSuspensa.vue?vue&type=style&index=0&id=ddf85f58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf85f58",
  null
  
)

export default component.exports